/* eslint-disable max-len */
import React, { Fragment } from 'react';
import { BlockSpan } from './styles';

export default {
  financialStrengthRating: sup => ({
    title: <Fragment>A&#43;&#43;</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> financial strength rating</Fragment>,
    description: <Fragment>AAA, Aaa, and AA&#43; maintaining the highest financial strength ratings of any life insurer from all major rating agencies during this pandemic<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Awarded in the Insurance category: Life &amp; Health industry, <cite>Fortune&#174; Magazine&#39;s annual survey, 2017</cite></Fragment>,
  }),
  rankedInvestmentService: sup => ({
    title: <Fragment>Top 5</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> ranked investment service</Fragment>,
    description: <Fragment>ranked among the top U.S. Independent Investment Broker&#45;Dealers<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Ranking for Northwestern Mutual Investment Services LLC, <cite>Financial Advisor magazine and InvestmentNews, May 2020</cite></Fragment>,
  }),
  yearsOfService: () => ({
    title: <Fragment>160&#43;</Fragment>,
    blockquote: false,
    assistiveTitle: <Fragment> years strong through depressions, downturns, two world wars, and pandemics</Fragment>,
    description: <Fragment>years strong through depressions, downturns, two world wars, and pandemics</Fragment>,
    footer: null,
  }),
  dividend: sup => ({
    title: <Fragment>&#36;6.2B</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> in dividends expected to be paid in 2021</Fragment>,
    description: <Fragment>in dividends expected to be paid in 2021<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Dividends are reviewed annually and are not guaranteed.</Fragment>,
  }),
  rankedInsuranceCompany: sup => ({
    title: <Fragment>No. 1</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> overall&#45;ranked insurance company</Fragment>,
    description: <Fragment>Best Life Insurance Company ranked by NerdWallet, 2020<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Ranking for Northwestern Mutual Investment Services LLC, <cite>&#169;2017&#8211;2020 and TM, NerdWallet, Inc. All Rights Reserved.</cite></Fragment>,
  }),
  policyholderRetention: sup => ({
    title: <Fragment>96&#37;</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> of our policyowners stay with us year over year.</Fragment>,
    description: <Fragment>of our policyowners stay with us year over year<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Statistic for Northwestern Mutual, <cite>based on Northwestern Mutual policyowner data.</cite></Fragment>,
  }),
  moodysInvestorsService: sup => ({
    title: <Fragment>Aaa</Fragment>,
    blockquote: true,
    description: <Fragment><BlockSpan uppercase={true}>Highest</BlockSpan><BlockSpan>Moody&#39;s Investors Service<sup>{sup}</sup></BlockSpan><BlockSpan>December 2020</BlockSpan></Fragment>,
    footer: <Fragment><cite>December 2020</cite></Fragment>,
  }),
  AMBestCompany: sup => ({
    title: <Fragment>A&#43;&#43;</Fragment>,
    blockquote: true,
    description: <Fragment><BlockSpan uppercase={true}>Highest</BlockSpan><BlockSpan>A.M. Best Company<sup>{sup}</sup></BlockSpan><BlockSpan>April 2020</BlockSpan></Fragment>,
    footer: <Fragment><cite>April 2020</cite></Fragment>,
  }),
  fitchRatings: sup => ({
    title: <Fragment>AAA</Fragment>,
    blockquote: true,
    description: <Fragment><BlockSpan uppercase={true}>Highest</BlockSpan><BlockSpan>Fitch Ratings<sup>{sup}</sup></BlockSpan><BlockSpan>August 2020</BlockSpan></Fragment>,
    footer: <Fragment><cite>August 2020</cite></Fragment>,
  }),
  SPGlobalRatings: sup => ({
    title: <Fragment>AA&#43;</Fragment>,
    blockquote: true,
    description: <Fragment><BlockSpan uppercase={true}>Second Highest</BlockSpan><BlockSpan>S&#38;P Global Ratings<sup>{sup}</sup></BlockSpan><BlockSpan>June 2020</BlockSpan></Fragment>,
    footer: <Fragment><cite>June 2020</cite></Fragment>,
  }),
  communityDonations: () => ({
    title: <Fragment>&#36;400M&#43;</Fragment>,
    blockquote: true,
    description: <Fragment>given to our communities since 1992</Fragment>,
  }),
  childhoodCancerDonations: () => ({
    title: <Fragment>&#36;35M&#43;</Fragment>,
    blockquote: true,
    description: <Fragment>given to support the fight against childhood cancer</Fragment>,
  }),
  childhoodCancerResearch: () => ({
    title: <Fragment>455K&#43;</Fragment>,
    blockquote: true,
    description: <Fragment>hours of childhood cancer research funded</Fragment>,
  }),
  COVIDReliefDonations: () => ({
    title: <Fragment>&#36;2M&#43;</Fragment>,
    blockquote: true,
    description: <Fragment>In national COVID&#45;19 relief</Fragment>,
  }),
};
